/**
 * @internal
 */
export var Anchored;
(function (Anchored) {
    function compare(a, b) {
        return a.anchor.compare(b.anchor);
    }
    Anchored.compare = compare;
    function equals(a, b) {
        return a.anchor.equals(b.anchor);
    }
    Anchored.equals = equals;
})(Anchored || (Anchored = {}));
//# sourceMappingURL=anchored.js.map